<div class="container">
    <div class="text-right">
      <button
        class="btn btn-light hover-button mail"
        (click)="reportClick()"
        *ngIf="reportGenerate"
      >
        <mat-icon>description</mat-icon> &nbsp;Create voyage report
      </button>
  
      <button
        class="btn btn-light hover-button mail"
        (click)="uploadfile()"
        *ngIf="reportGenerate"
      >
        <mat-icon>file_upload</mat-icon>Upload File
      </button>
      <button class="btn btn-light hover-button mail" (click)="clearClick()">
        <mat-icon>clear_all</mat-icon> &nbsp;Clear
      </button>
      <button class="btn btn-light hover-button mail" (click)="submitClick()">
        <mat-icon>done</mat-icon> Submit
      </button>
    </div>
    <div class="bgv">
      <form [formGroup]="requestForm">
        <div class="row foddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for="">Use New Current Formula:</label>
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="yesNo"
              [controlname]="this.requestForm.controls['useNewCurrentFormula']"
            ></app-custom-radio-button>
          </div>
        </div>
        <!-- <div class="row fevenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""><span class="asterik-color">*</span>MerakiPic:</label>
          </div>
  
          <div class="col-md-8 textBox dropDown">
            <select
              formControlName="merakiPic"
              class="form-control"
              [ngClass]="{
                'error-border':
                  formSubmitted &&
                  requestForm.get('merakiPic')?.hasError('required')
              }"
            >
              <option
                *ngFor="
                  let option of merakiPicOptions;
                  even as isEven;
                  odd as isOdd
                "
                [ngValue]="option.value"
                [ngClass]="{ odd: isOdd, even: isEven }"
              >
                {{ option.label }}
              </option>
            </select>
            <small
              class="error"
              *ngIf="
                formSubmitted &&
                requestForm.get('merakiPic')?.hasError('required')
              "
            >
              <p class="ename">MerakiPic is required.</p>
            </small>
          </div>
        </div> -->

        <div class="row foddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""><span class="asterik-color">*</span>Ship:</label>
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-4">
                <label >Ship Name</label>
                <app-custom-input
                  [controlname]="this.requestForm.controls['ship']"
                  [errorMessage]="'Ship Name is required'"
                  [formSubmitted]="formSubmitted"
                ></app-custom-input>
              </div>
              <div class="col-md-3">
                <label >I.M.O Number</label>
                <app-custom-input
                  [errorMessage]="'IMO Numberis required'"
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['imoNumber']"
                ></app-custom-input>
              </div>
              <div class="col-md-3">
                <label >Voyage Number</label>
                <app-custom-input
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['voyNumber']"
                  (onInput)="onVoyageChange($event, 'voyNumber')"
                ></app-custom-input>
              </div>
              <div class="col-md-2">
                <label >Segment</label>
                <app-custom-dropdown
                  [items]="segmentOptions"
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['segment']"
                ></app-custom-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""><span class="asterik-color"></span>Ship Yard:</label>
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-4">
                <label >Ship Yard</label>
                <app-custom-dropdown
                  [items]="shipyardOptions"
                  [requiredErrorMessage]="' ShipYard is required'"
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['shipYard']"
                ></app-custom-dropdown>
              </div>
  
              <div class="col-md-4">
                <label >Year Built</label>
                <app-custom-input
                  [errorMessage]="'Year Built  is required'"
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['yearBuilt']"
                ></app-custom-input>
              </div>
              <div class="col-md-4">
                <label >Type of ship</label>
                <app-custom-dropdown
                  [items]="typeofshipOptions"
                  [requiredErrorMessage]="' type of ship is required'"
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['typeOfShip']"
                ></app-custom-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""><span class="asterik-color">*</span>Ports:</label>
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-6">
                <label >From</label>
                <input
                  type="text"
                  class="form-control"
                  id="portName"
                  formControlName="pFrom"
                  (input)="filterPortNames($event)"
                  [matAutocomplete]="auto"
                  [ngClass]="{
                    'error-border':
                      formSubmitted &&
                      requestForm.get('pFrom')?.hasError('required')
                  }"
                />
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option
                    *ngFor="let suggestion of portNameSuggestions"
                    [value]="suggestion.port_name"
                  >
                    {{ suggestion.port_name }}
                  </mat-option>
                </mat-autocomplete>
                <small
                  class="error"
                  *ngIf="
                    formSubmitted &&
                    requestForm.get('pFrom')?.hasError('required')
                  "
                >
                  <p class="ename">From is required.</p>
                </small>
              </div>
              <div class="col-md-6">
                <label >To</label>
                <input
                  type="text"
                  class="form-control"
                  id="to"
                  formControlName="pTo"
                  (input)="filterPortNames($event)"
                  [matAutocomplete]="auto"
                  [ngClass]="{
                    'error-border':
                      formSubmitted &&
                      requestForm.get('pTo')?.hasError('required')
                  }"
                />
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option
                    *ngFor="let suggestion of portNameSuggestions"
                    [value]="suggestion.port_name"
                  >
                    {{ suggestion.port_name }}
                  </mat-option>
                </mat-autocomplete>
                <small
                  class="error"
                  *ngIf="
                    formSubmitted && requestForm.get('pTo')?.hasError('required')
                  "
                >
                  <p class="ename">To is required.</p>
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="row evenBgv datesBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""><span class="asterik-color"></span>ETA(LT):</label>
          </div>
          <div class="col-md-8 textBox1">
            <div class="row">
              <div class="col-md-6">
                <app-custom-date-picker
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['etaDate']"
                ></app-custom-date-picker>
              </div>
              <div class="col-md-6 time-picker">
                <input
                  placeholder="HH"
                  type="number"
                  id="hour"
                  class="form-control time"
                  min="0"
                  max="24"
                  formControlName="etaHours"
                  (input)="restrictInput($event.target, 24)"
                  [ngClass]="{
                    'error-border':
                      formSubmitted &&
                      requestForm.get('etaHours')?.hasError('required')
                  }"
                />
  
                <input
                  placeholder="MM"
                  type="number"
                  id="minute"
                  class="form-control time"
                  min="0"
                  max="59"
                  formControlName="etaMinutes"
                  (input)="restrictInput($event.target, 59)"
                  [ngClass]="{
                    'error-border':
                      formSubmitted &&
                      requestForm.get('etaMinutes')?.hasError('required')
                  }"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="row oddBgv datesBgv"
          [ngClass]="{ 'dark-odd': isDarkMode() }"
        >
          <div class="col-md-4">
            <label for=""
              ><span *ngIf="datesValidator" class="asterik-color">*</span
              >Dates:</label
            >
          </div>
  
          <div class="col-md-8 textBox1">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <label >COSP</label>
                    <app-custom-date-picker
                      [errorMessage]="'COSP is required'"
                      [formSubmitted]="formSubmitted"
                      [controlname]="this.requestForm.controls['cosp']"
                    ></app-custom-date-picker>
                  </div>
                  <div class="col-md-6">
                    <div class="time-picker">
                      <input
                        placeholder="HH"
                        type="number"
                        id="hour"
                        class="form-control time"
                        min="0"
                        max="24"
                        formControlName="cospHours"
                        (input)="restrictInput($event.target, 24)"
                        [ngClass]="{
                          'error-border':
                            formSubmitted &&
                            requestForm.get('cospHours')?.hasError('required')
                        }"
                      />
  
                      <input
                        placeholder="MM"
                        type="number"
                        id="minute"
                        class="form-control time"
                        min="0"
                        max="59"
                        formControlName="cospMinutes"
                        (input)="restrictInput($event.target, 59)"
                        [ngClass]="{
                          'error-border':
                            formSubmitted &&
                            requestForm.get('cospMinutes')?.hasError('required')
                        }"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <label >EOSP</label>
                    <app-custom-date-picker
                      [errorMessage]="'EOSP is required'"
                      [formSubmitted]="formSubmitted"
                      [controlname]="this.requestForm.controls['eosp']"
                    ></app-custom-date-picker>
                  </div>
                  <div class="col-md-6">
                    <div class="time-picker">
                      <input
                        placeholder="HH"
                        type="number"
                        id="hour"
                        class="form-control time"
                        min="0"
                        max="24"
                        formControlName="eospHours"
                        (input)="restrictInput($event.target, 24)"
                        [ngClass]="{
                          'error-border':
                            formSubmitted &&
                            requestForm.get('eospHours')?.hasError('required')
                        }"
                      />
  
                      <input
                        placeholder="MM"
                        type="number"
                        id="minute"
                        class="form-control time"
                        min="0"
                        max="59"
                        formControlName="eospMinutes"
                        (input)="restrictInput($event.target, 59)"
                        [ngClass]="{
                          'error-border':
                            formSubmitted &&
                            requestForm.get('eospMinutes')?.hasError('required')
                        }"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""><span class="asterik-color">*</span>Client Name:</label>
          </div>
          <div class="col-md-8 textBox">
            <app-custom-dropdown
              [items]="clientOptions"
              [formSubmitted]="formSubmitted"
              [requiredErrorMessage]="' Client is required'"
              [controlname]="this.requestForm.controls['client']"
            ></app-custom-dropdown>
            <!-- <app-custom-input
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['client']"
              [readonly]="true"
            ></app-custom-input> -->
          </div>
        </div>
          
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              >Template:</label
            >
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="templetOptions"
              [controlname]="this.requestForm.controls['templete']"
            >
              ></app-custom-radio-button
            >
          </div>
        </div>
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Weather Source:</label
            >
          </div>
          <div class="col-md-8 textBox dropDown">
            <select
              formControlName="weatherSource"
              class="form-control"
              [ngClass]="{
                'error-border':
                  formSubmitted &&
                  requestForm.get('weatherSource')?.hasError('required')
              }"
            >
              <option
                *ngFor="
                  let option of weatherSourceOptions;
                  even as isEven;
                  odd as isOdd
                "
                [ngValue]="option.value"
                [ngClass]="{ odd: isOdd, even: isEven }"
              >
                {{ option.label }}
              </option>
            </select>
            <small
              class="error"
              *ngIf="
                formSubmitted &&
                requestForm.get('weatherSource')?.hasError('required')
              "
            >
              <p class="ename">Weather Source is required.</p>
            </small>
          </div>
        </div>
  
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Type of speed:</label
            >
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="typeOfSpeedOptions"
              [controlname]="this.requestForm.controls['typeSpeed']"
            >
              ></app-custom-radio-button
            >
          </div>
        </div>
  
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""><span class="asterik-color">*</span>Voyage Type:</label>
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="voyageTypeOptions"
              [controlname]="this.requestForm.controls['voyageType']"
            ></app-custom-radio-button>
          </div>
        </div>
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""><span class="asterik-color">*</span>Report Type:</label>
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="reportTypeOptions"
              [controlname]="this.requestForm.controls['reportType']"
            ></app-custom-radio-button>
          </div>
        </div>

        <!-- Mid-Voyage Lock Options -->
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for="">Mid-Voyage Data Lock:</label>
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-4 checkBox" style="padding-top: 8px;">
                <mat-checkbox
                  formControlName="has_mid_voyage"
                  color="primary"
                >Has Mid-Voyage Report</mat-checkbox>
              </div>
              <div class="col-md-8" *ngIf="requestForm.get('has_mid_voyage')?.value">
                <label style="font-size: 11px; margin-bottom: 2px;">Lock data until (UTC)</label>
                <input
                  type="datetime-local"
                  formControlName="lock_until_date"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
  
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>C/P ordered
              speed(Knots):</label
            >
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-12">
                <app-custom-input
                  [errorMessage]="'C/P ordered speed is required'"
                  [formSubmitted]="formSubmitted"
                  (onInput)="numberInput($event, 'cpOrderedSpeed')"
                  [controlname]="this.requestForm.controls['cpOrderedSpeed']"
                ></app-custom-input>
              </div>
              <!-- <div class="col-md-6 checkBox">
                <mat-checkbox
                  class="example-margin"
                  id="multipleSpeedCheckbox"
                  formControlName="multipleSpeed"
                  color="primary"
                  >Multiple Speed</mat-checkbox
                >
              </div> -->
            </div>
          </div>
        </div>
       
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Fuel Type Used:</label
            >
          </div>
  
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-4">
                <app-custom-dropdown
                  [placeholder]="
                    requestForm.controls['fuelType'].value
                      ? null
                      : 'HSFO/VLSFO/ULSFO'
                  "
                  [items]="fuelType"
                  [requiredErrorMessage]="'Fuel Type is required'"
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['fuelType']"
                ></app-custom-dropdown>
              </div>
              <div class="col-md-4">
                <app-custom-dropdown
                  [placeholder]="
                    requestForm.controls['fuelTypeOne'].value ? null : 'GO/MDO'
                  "
                  [items]="fuelType"
                  [requiredErrorMessage]="'Fuel Type is required'"
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['fuelTypeOne']"
                ></app-custom-dropdown>
              </div>
              <div class="col-md-4">
                <app-custom-dropdown
                  [placeholder]="
                    requestForm.controls['fuelTypeTwo'].value ? null : 'OTHERS'
                  "
                  [items]="fuelType"
                  [requiredErrorMessage]="'Fuel Type is required'"
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['fuelTypeTwo']"
                ></app-custom-dropdown>
              </div>
            </div>
          </div>
        </div>
  
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for="">C/P Consumption(MT):</label>
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-4">
                <app-custom-input
                  [placeholder]="'HSFO/VLSFO/ULSFO'"
                  [errorMessage]="'HSFO/VLSFO/ULSFO is required'"
                  [formSubmitted]="formSubmitted"
                  (onInput)="onInput($event, 'cpFuel')"
                  [controlname]="this.requestForm.controls['cpFuel']"
                ></app-custom-input>
              </div>
              <div class="col-md-4">
                <app-custom-input
                  [placeholder]="'GO/MDO'"
                  [errorMessage]="'GO/MDO is required'"
                  [formSubmitted]="formSubmitted"
                  (onInput)="onInput($event, 'cpFuelOne')"
                  [controlname]="this.requestForm.controls['cpFuelOne']"
                ></app-custom-input>
              </div>
              <div class="col-md-4">
                <app-custom-input
                  [placeholder]="'OTHERS'"
                  [errorMessage]="'C/P Consumption(MT) is required'"
                  [formSubmitted]="formSubmitted"
                  (onInput)="onInput($event, 'cpOthers')"
                  [controlname]="this.requestForm.controls['cpOthers']"
                ></app-custom-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>MGO AE Cons Exculded:</label
            >
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="duelFuelOptions"
              [controlname]="this.requestForm.controls['duelFuel']"
            ></app-custom-radio-button>
          </div>
        </div>
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color"></span>Cp Ordered Consumption
              GO:</label
            >
          </div>
          <div class="col-md-8 textBox">
            <app-custom-input
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['cpGasOil']"
              (onInput)="numberInput($event, 'cpGasOil')"
            ></app-custom-input>
          </div>
        </div>
  
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Weather calculation:</label
            >
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="wetherCalculationOptions"
              [controlname]="this.requestForm.controls['wetherCalculation']"
            ></app-custom-radio-button>
          </div>
        </div>
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""><span class="asterik-color">*</span>DSS Limit:</label>
          </div>
          <div class="col-md-8 textBox">
            <app-custom-input
              [errorMessage]="'BF Limit DSS is required'"
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['bfLimitDss']"
              (onInput)="numberInput($event, 'bfLimitDss')"
            ></app-custom-input>
          </div>
        </div>
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Wind Beaufort(BF):</label
            >
          </div>
          <div class="col-md-8 textBox">
            <app-custom-input
              [errorMessage]="'Wind Beaufort is required'"
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['windBeaufort']"
              (onInput)="numberInput($event, 'windBeaufort')"
            ></app-custom-input>
          </div>
        </div>
  
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Wind Wave(in meter):</label
            >
          </div>
          <div class="col-md-8 textBox">
            <app-custom-input
              (onInput)="numberInput($event, 'windWave')"
              [errorMessage]="'Wind Wave is required'"
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['windWave']"
            ></app-custom-input>
          </div>
        </div>
  
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Swell Height(DSS)(in
              meter):</label
            >
          </div>
          <div class="col-md-8 textBox">
            <app-custom-input
              [errorMessage]="'Swell Heigh is required'"
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['swellHeight']"
              (onInput)="numberInput($event, 'swellHeight')"
            ></app-custom-input>
          </div>
        </div>
  
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Significant Wave(in
              meter):</label
            >
          </div>
          <div class="col-md-8 textBox">
            <app-custom-input
              [errorMessage]="'Significant Wave is required'"
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['significantWave']"
              (onInput)="numberInput($event, 'significantWave')"
            ></app-custom-input>
          </div>
        </div>
  
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Adverse current
              excluded?:</label
            >
          </div>
  
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="adverseCurrentValue"
              [controlname]="this.requestForm.controls['adverseCurrent']"
            ></app-custom-radio-button>
          </div>
        </div>
  
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Current factor:</label
            >
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="yesNo"
              [controlname]="this.requestForm.controls['currentFactor']"
            ></app-custom-radio-button>
          </div>
        </div>
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Periodic current factor(3
              Hourly):</label
            >
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="yesNo"
              [controlname]="this.requestForm.controls['periodiccurrentfactor']"
            ></app-custom-radio-button>
          </div>
        </div>

        <!-- <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for="">Current- only negative to be considered:</label>
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="yesNo3"
              [controlname]="this.requestForm.controls['currentOnlyNeg']"
            ></app-custom-radio-button>
          </div>
        </div> -->
  
        <!-- <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for="">Adverse swell excluded :</label>
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="yesNo"
              [controlname]="this.requestForm.controls['adverseSwellEx']"
            ></app-custom-radio-button>
          </div>
        </div> -->
  
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Good weather period defined as
              per C/P:</label
            >
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-6">
                <app-custom-dropdown
                  [items]="goodWeatherPeriod"
                  [requiredErrorMessage]="
                    'Good weather period defined as per C/P is required'
                  "
                  [formSubmitted]="formSubmitted"
                  [controlname]="this.requestForm.controls['goodWeatherPeriod']"
                ></app-custom-dropdown>
              </div>
              <div class="col-md-6 checkBox">
                <mat-checkbox
                  class="example-margin"
                  id="hoursNeedToBeCon"
                  formControlName="hoursNeedToBeCon"
                  color="primary"
                  > <span class="checkboxLabel">
                  Hours Need To Be Continuous
                </span></mat-checkbox
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
            <div class="col-md-4">
              <label for="">24 Hours Positive:</label>
            </div>
            <div class="col-md-8 radioButton">
              <app-custom-radio-button
                [options]="yesNoDayPositive"
                [controlname]="this.requestForm.controls['allDayPositive']"
              ></app-custom-radio-button>
            </div>
          </div>
  
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Performance calculation:</label
            >
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="performanceCalOptions"
              [controlname]="this.requestForm.controls['performanceCal']"
            ></app-custom-radio-button>
          </div>
        </div>
  
        <!-- <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for="">1st and last 24hrs:</label>
          </div>
          <div class="col-md-8 radioCheckButton">
            <div class="row">
              <div class="col-md-6 mCheckBox">
                <mat-checkbox
                  class="example-margin"
                  id="excludeFirst"
                  formControlName="excludeFirst"
                  color="primary"
                  >Exclude 1st 24 hrs</mat-checkbox
                >
              </div>
              <div class="col-md-6 mCheckBox">
                <mat-checkbox
                  class="example-margin"
                  id="excludeLast"
                  formControlName="excludeLast"
                  color="primary"
                  >Exclude last 24 hrs</mat-checkbox
                >
              </div>
            </div>
          </div>
        </div> -->
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""><span class="asterik-color">*</span>About S&C:</label>
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="yesNo"
              [controlname]="this.requestForm.controls['aboutSc']"
            ></app-custom-radio-button>
          </div>
        </div>
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>About Speed Min
              Tolerence(minus):</label
            >
          </div>
          <div class="col-md-8 textBox">
            <app-custom-input
              [errorMessage]="'About Speed Min Tolerence is required'"
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['speedMinTol']"
              (onInput)="numberInput($event, 'speedMinTol')"
            ></app-custom-input>
          </div>
        </div>
  
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>About Speed Max
              Tolerence(plus):</label
            >
          </div>
  
          <div class="col-md-8 textBox">
            <app-custom-input
              [errorMessage]="'About Speed Max Tolerence is required'"
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['speedMaxTol']"
              (onInput)="numberInput($event, 'speedMaxTol')"
            ></app-custom-input>
          </div>
        </div>
  
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>About Cons Min Tolerence(minus)
              as %:</label
            >
          </div>
          <div class="col-md-8 textBox">
            <app-custom-input
              [errorMessage]="'About Cons Min Tolerence as % is required'"
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['consMinTol']"
              (onInput)="numberInput($event, 'consMinTol')"
            ></app-custom-input>
          </div>
        </div>
  
        <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>About Cons Max Tolerence(plus)
              as %:</label
            >
          </div>
          <div class="col-md-8 textBox">
            <app-custom-input
              [errorMessage]="'About Cons Max Tolerence as % is required'"
              [formSubmitted]="formSubmitted"
              [controlname]="this.requestForm.controls['consMaxTol']"
              (onInput)="numberInput($event, 'consMaxTol')"
            ></app-custom-input>
          </div>
        </div>
  
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for=""
              ><span class="asterik-color">*</span>Extrapolation method:</label
            >
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="yesNo"
              [controlname]="this.requestForm.controls['extrapolationMethod']"
            ></app-custom-radio-button>
          </div>
        </div>
  
        <!-- <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for="">SECA or ECA:</label>
          </div>
          <div class="col-md-8 radioButton">
            <app-custom-radio-button
              [options]="yesNo"
              [controlname]="this.requestForm.controls['secaEca']"
            ></app-custom-radio-button>
          </div>
        </div> -->
  

        <!-- <div class="row oddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for="">Repoted Position:</label>
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <label >Current Latitude</label>
                    <app-custom-input
                      (onInput)="numberInput($event, 'currLat')"
                      [controlname]="this.requestForm.controls['currLat']"
                    ></app-custom-input>
                  </div>
                  <div class="col-md-6">
                    <label >Direction</label>
                    <app-custom-dropdown
                      [items]="latDir"
                      [controlname]="this.requestForm.controls['latDir']"
                    ></app-custom-dropdown>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <label >Current Longitude</label>
                    <app-custom-input
                      (onInput)="numberInput($event, 'currLng')"
                      [controlname]="this.requestForm.controls['currLng']"
                    ></app-custom-input>
                  </div>
                  <div class="col-md-6">
                    <label >Direction</label>
                    <app-custom-dropdown
                      [items]="longDir"
                      [controlname]="this.requestForm.controls['longDir']"
                    ></app-custom-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row evenBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for="">Repoted Weather:</label>
          </div>
          <div class="col-md-8 textBox">
            <div class="row">
              <div class="col-md-3">
                <label >Wind(BF)</label>
                <app-custom-input
                  [controlname]="this.requestForm.controls['repWindBf']"
                ></app-custom-input>
              </div>
              <div class="col-md-3">
                <label >Swell Height(m)</label>
                <app-custom-input
                  (onInput)="numberInput($event, 'repSwell')"
                  [controlname]="this.requestForm.controls['repSwell']"
                ></app-custom-input>
              </div>
              <div class="col-md-3">
                <label >Avg Speed(24hr)</label>
                <app-custom-input
                  (onInput)="numberInput($event, 'repAvgSpeed')"
                  [controlname]="this.requestForm.controls['repAvgSpeed']"
                ></app-custom-input>
              </div>
              <div class="col-md-3">
                <label >Avg Speed(Voyage)</label>
                <app-custom-input
                  (onInput)="numberInput($event, 'voyAvgSpeed')"
                  [controlname]="this.requestForm.controls['voyAvgSpeed']"
                ></app-custom-input>
              </div>
            </div>
          </div>
        </div> -->
  
        <div class="row mainoddBgv" [ngClass]="{ 'dark-odd': isDarkMode() }">
          <div class="col-md-4">
            <label for="" class="mainCp">Main C/P:</label>
          </div>
          <div class="col-md-8 textarea">
            <textarea
              [ngClass]="{
                invalid:
                  formSubmitted && this.requestForm.controls['mainCp'].invalid
              }"
              id="mainCp"
              name="mainCp"
              class="form-control"
              formControlName="mainCp"
            ></textarea>
            <div
              *ngIf="
                formSubmitted && this.requestForm.controls['mainCp']?.invalid
              "
              class="error-message"
            >
              <p
                class="ename"
                *ngIf="this.requestForm.controls['mainCp']?.errors?.['required']"
              >
                Main C/P is required
              </p>
              <p
                *ngIf="this.requestForm.controls['mainCp']?.errors?.['maxWordsExceeded']"
                class="ename"
              >
                Main C/P is required Only 1500 words
              </p>
            </div>
            <input
              type="file"
              hidden
              #fileUpload
              (change)="onFileSelectedimage($event)"
              accept=".png, .jpg , .pdf"
            />
            <div class="button">
              <button *ngIf="mainCpFile"  class="btn btn-light hover-button mail mainCpFile"  (click)="viewMainCp(this.requestForm.value)"  >
                <mat-icon>photo_outline</mat-icon> View File
              </button>
              <button
                class="btn btn-light hover-button mail"
                (click)="uploadMainCp()"
              >
                <mat-icon>file_upload</mat-icon>Upload Image
              </button>
            </div>
  
            <!-- <div
              *ngIf="
                formSubmitted && this.requestForm.controls['mainCp']?.invalid
              "
              class="error-message"
            >
              <p class="ename">Main C/P is required</p>
            </div> -->
          </div>
        </div>
        <div class="row evenLastBgv" [ngClass]="{ 'dark-even': isDarkMode() }">
          <div class="col-md-4">
            <label for="">Any Additional Comments:</label>
          </div>
          <div class="col-md-8 textarea">
            <textarea
              id="additionalComments"
              name="additionalComments"
              class="form-control"
              formControlName="additionalComments"
            ></textarea>
          </div>
        </div>
      </form>
    </div>
    <div class="text-right">
      <button class="btn btn-light hover-button mail" (click)="topClick()">
        <mat-icon>arrow_upward</mat-icon> &nbsp;Go top
      </button>
      <button
        class="btn btn-light hover-button mail"
        (click)="reportClick()"
        *ngIf="reportGenerate"
      >
        <mat-icon>description</mat-icon> &nbsp;Create voyage report
      </button>
      <button
        class="btn btn-light hover-button mail"
        (click)="uploadfile()"
        *ngIf="reportGenerate"
      >
        <mat-icon>file_upload</mat-icon>Upload File
      </button>
      <button class="btn btn-light hover-button mail" (click)="clearClick()">
        <mat-icon>clear_all</mat-icon> &nbsp;Clear
      </button>
      <button class="btn btn-light hover-button mail" (click)="submitClick()">
        <mat-icon>done</mat-icon> Submit
      </button>
    </div>
    <br />
  </div>
  <input
    type="file"
    hidden
    #fileInput
    (change)="onFileSelected($event)"
    accept=".xlsx, .xls , .xlsm, .csv"
  />
  